import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/warehouse-management/price-list`;

export const priceListRoutesObj = {
  list: baseRoute,
  insertNewPrice: `${baseRoute}/insert-new-price/:productId/`,
  itemPriceHistory: `${baseRoute}/item-price-history/:productId`,
} as const;

export type IPriceListRouteParams = IExtractRouteParamMap<
  typeof priceListRoutesObj
>;

export const priceListPath = createPaths<
  typeof priceListRoutesObj,
  IPriceListRouteParams
>(priceListRoutesObj);
